import { Injectable } from '@angular/core';
import { IAnswer, IChoice, IQuestionGroup, IQuestionSet } from 'src/app/models/application-form/application-form.model';
import { FormDataAbstractService } from './form-data.abstract.service';
@Injectable({
  providedIn: 'root'
})
export class FormDataService implements FormDataAbstractService {
  private formId: string;
  private contactQuestionSet: IQuestionSet;
  private productQuestionSet: IQuestionSet;
  private businessTypeQuestionSet: IQuestionSet;
  private generalQuestionSet: IQuestionSet;
  private questionSets: IQuestionSet[];

  public get FormId(): string {
    if (!this.formId) {
      this.formId = this.formId = crypto.randomUUID();
    }
    return this.formId;
  }
  public get ContactQuestionSet(): IQuestionSet {
    if (!this.contactQuestionSet) {
      this.contactQuestionSet = this.createContactInfoQuestionSet(
        this.FormId,
        [],
        null,
        'progressive_commercial_contact',
        crypto.randomUUID(),
        1
      );
    }
    return this.contactQuestionSet;
  }
  public get ProductQuestionSet(): IQuestionSet {
    if (!this.productQuestionSet) {
      this.productQuestionSet = this.createCoverageTypeQuestionSet(
        this.FormId,
        [],
        null,
        'progressive_commercial_overview',
        crypto.randomUUID(),
        2
      );
    }
    return this.productQuestionSet;
  }
  public get BusinessTypeQuestionSet(): IQuestionSet {
    if (!this.businessTypeQuestionSet) {
      this.businessTypeQuestionSet = this.createBusinessTypeQuestionSet(
        this.FormId,
        [],
        null,
        'progressive_commercial_business_type',
        crypto.randomUUID(),
        3
      );
    }
    return this.businessTypeQuestionSet;
  }
  public get GeneralQuestionSet(): IQuestionSet {
    if (!this.generalQuestionSet) {
      this.generalQuestionSet = this.createSDKQuestionSet(this.FormId, [], null, 'progressive_commercial_general', crypto.randomUUID(), 4);
    }
    return this.generalQuestionSet;
  }

  public get QuestionSets(): IQuestionSet[] {
    if (!this.questionSets) {
      this.questionSets = [this.ContactQuestionSet, this.ProductQuestionSet, this.BusinessTypeQuestionSet, this.GeneralQuestionSet];
    }

    return this.questionSets;
  }

  public ResetData(): void {
    this.formId = null;
    this.contactQuestionSet = null;
    this.productQuestionSet = null;
    this.businessTypeQuestionSet = null;
    this.generalQuestionSet = null;
    this.questionSets = null;
  }

  private createSDKQuestionSet(
    formid: string,
    answers: IAnswer[],
    questionSet: IQuestionSet,
    code: string,
    queSetId: string,
    order: number
  ): IQuestionSet {
    const answer: IAnswer = this.createNewAnswer(
      formid,
      'progressive_commercial_General',
      queSetId,
      'text',
      'General Type',
      null,
      null,
      true,
      null,
      '',
      null,
      null
    );
    answers.push(answer);
    questionSet = this.createNewQuestionSet(answers, code, 'Progressive Eligibility', 'General', formid, queSetId, order);
    return questionSet;
  }
  private createContactInfoQuestionSet(
    formid: string,
    answers: IAnswer[],
    questionSet: IQuestionSet,
    code: string,
    queSetId: string,
    order: number
  ): IQuestionSet {
    const nameGroupId = crypto.randomUUID();
    const addressGroupId = crypto.randomUUID();

    const firstname: IAnswer = this.createNewAnswer(
      formid,
      'progressive_commercial_first_name',
      queSetId,
      'text',
      'First name',
      'Please enter your first name',
      null,
      true,
      'First name',
      null,
      null,
      null,
      null,
      null,
      true,
      null,
      null,
      nameGroupId
    );
    answers.push(firstname);

    const middleinitial: IAnswer = this.createNewAnswer(
      formid,
      'progressive_commercial_middle_initial',
      queSetId,
      'text',
      'Middle Initial',
      'Please enter your middle initial',
      null,
      false,
      'MI',
      '[A-Za-z]',
      null,
      null,
      0,
      1,
      true,
      null,
      null,
      nameGroupId
    );
    answers.push(middleinitial);

    const lastname: IAnswer = this.createNewAnswer(
      formid,
      'progressive_commercial_last_name',
      queSetId,
      'text',
      'Last name',
      'Please enter your last name',
      null,
      true,
      'Last name',
      null,
      null,
      null,
      null,
      null,
      true,
      null,
      null,
      nameGroupId
    );
    answers.push(lastname);

    const email: IAnswer = this.createNewAnswer(
      formid,
      'progressive_commercial_email',
      queSetId,
      'email',
      'Email address',
      'Please enter a valid email address',
      null,
      true,
      null,
      '^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z0-9]{2,}$',
      0,
      2000,
      null,
      null,
      null,
      null,
      'Your information will be used so we can send information and/or discuss your quote and insurance policy with you and will never be sold to any third party.'
    );
    answers.push(email);

    const phone: IAnswer = this.createNewAnswer(
      formid,
      'progressive_commercial_phone',
      queSetId,
      'phone',
      'Telephone number',
      'Please enter a valid telephone number.',
      null,
      true,
      null,
      '^[1-9][0-9]+',
      10,
      14
    );
    answers.push(phone);

    const businessname: IAnswer = this.createNewAnswer(
      formid,
      'progressive_commercial_business_name',
      queSetId,
      'text',
      'Business name',
      'Please enter your business name.',
      null,
      true,
      null,
      '^[^<>%\\|~*^\\\\_=\\{\\}\\[\\]]*$',
      0,
      100,
      null,
      null,
      null,
      null,
      'Please enter the legal name of your business. If you are a sole proprietorship then enter your own name or trading name. If you are registered as a DBA (doing business as), please type your name as "DBA business name." Your insurance documents will be printed with the company name exactly as you enter it.'
    );
    answers.push(businessname);

    const address1: IAnswer = this.createNewAnswer(
      formid,
      'progressive_commercial_address_1',
      queSetId,
      'text',
      'Street number & name',
      'Please enter a physical street address (Eg. 123 Main Street).',
      null,
      true,
      'Street number & name',
      '^[^<>"%;:!\\)\\("+\\|~*?^$_=+\\{\\}\\[\\]]*$',
      0,
      60,
      null,
      null,
      true,
      null,
      null,
      addressGroupId
    );
    answers.push(address1);

    const address2: IAnswer = this.createNewAnswer(
      formid,
      'progressive_commercial_address_2',
      queSetId,
      'text',
      'Suite / Apt Number',
      'Please enter a valid apt number.',
      null,
      false,
      'Suite / Apt Number',
      '^[^<>"%;:!\\)\\("+\\|~*?^$_=+\\{\\}\\[\\]]*$',
      0,
      60,
      null,
      null,
      true,
      null,
      null,
      addressGroupId
    );
    answers.push(address2);

    const city: IAnswer = this.createNewAnswer(
      formid,
      'progressive_commercial_city',
      queSetId,
      'text',
      'City',
      'Please enter a valid city.',
      null,
      true,
      'City',
      '^[^<>"%;:!\\)\\("+\\|~*?^$_=+\\{\\}\\[\\]]*$',
      null,
      null,
      null,
      null,
      true,
      null,
      null,
      addressGroupId
    );
    answers.push(city);

    const state: IAnswer = this.createNewAnswer(
      formid,
      'progressive_commercial_state',
      queSetId,
      'dropdown',
      'State',
      'Please choose your state.',
      null,
      true,
      'State',
      '',
      null,
      null,
      null,
      null,
      true,
      null,
      null,
      addressGroupId
    );
    const states = this.getStates(state.question.id);
    state.question.choices = states;
    answers.push(state);

    const zipcode: IAnswer = this.createNewAnswer(
      formid,
      'progressive_commercial_zipcode',
      queSetId,
      'zipcode',
      'Zip Code',
      'Please enter a valid zip code. If your zip code is less than 5 digits, please preface it with 0, e.g., 01234.',
      null,
      true,
      'Zip Code',
      '^\\d{5}$',
      5,
      5,
      null,
      null,
      true,
      null,
      null,
      addressGroupId
    );
    answers.push(zipcode);

    const questionGroups: IQuestionGroup[] = [];
    const nameQuestionGroup: IQuestionGroup = {
      id: nameGroupId,
      group_type: 'full_name',
      // eslint-disable-next-line quotes
      label: "Business owner's name",
      question_ids: [firstname.question.id, middleinitial.question.id, lastname.question.id]
    };

    const addressQuestionGroup: IQuestionGroup = {
      id: addressGroupId,
      group_type: 'address',
      label: 'Physical business address',
      question_ids: [address1.question.id, address2.question.id, city.question.id, state.question.id, zipcode.question.id]
    };
    questionGroups.push(nameQuestionGroup, addressQuestionGroup);

    questionSet = this.createNewQuestionSet(
      answers,
      code,
      'ProgressiveCommercial.com Contact',
      'Contact',
      formid,
      queSetId,
      order,
      questionGroups
    );
    return questionSet;
  }
  private createCoverageTypeQuestionSet(
    formid: string,
    answers: IAnswer[],
    questionSet: IQuestionSet,
    code: string,
    queSetId: string,
    order: number
  ): IQuestionSet {
    const answer: IAnswer = this.createNewAnswer(
      formid,
      'progressive_commercial_product',
      queSetId,
      'dropdown',
      'Coverage Types',
      'Please select a valid answer.',
      null,
      true,
      null,
      '',
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      true
    );
    const products = this.getProducts(answer.question.id);
    answer.question.choices = products;
    answers.push(answer);
    questionSet = this.createNewQuestionSet(answers, code, 'ProgressiveCommercial.com Overview', 'Coverage', formid, queSetId, order);
    return questionSet;
  }
  private createBusinessTypeQuestionSet(
    formid: string,
    answers: IAnswer[],
    questionSet: IQuestionSet,
    code: string,
    queSetId: string,
    order: number
  ): IQuestionSet {
    const answer: IAnswer = this.createNewAnswer(
      formid,
      'progressive_commercial_naics',
      queSetId,
      'dropdown',
      'Business Type',
      null,
      null,
      true,
      null,
      '',
      null,
      null
    );
    answers.push(answer);
    questionSet = this.createNewQuestionSet(
      answers,
      code,
      'ProgressiveCommercial.com Business Type',
      'Business Type',
      formid,
      queSetId,
      order
    );
    return questionSet;
  }
  private createNewQuestionSet(
    answers: IAnswer[],
    code: string,
    name: string,
    title: string,
    formid: string,
    queSetId: string,
    order: number,
    question_groups?: IQuestionGroup[]
  ): IQuestionSet {
    return {
      answers: answers,
      question_set: {
        code: code,
        name: name,
        title: title,
        question_groups: question_groups
      },
      application_form_id: formid,
      id: queSetId,
      is_active: true,
      is_blank: false,
      is_completed: false,
      question_set_id: queSetId,
      order: order
    };
  }

  private createNewAnswer(
    formid: string,
    code: string,
    queSetId: string,
    fieldType: string,
    queText: string,
    errorText?: string,
    referenceType?: string,
    required = true,
    placeholder?: string,
    pattern?: string,
    minlength?: any,
    maxlength?: any,
    min?: any,
    max?: any,
    hide_label?: boolean,
    choices?: IChoice[],
    helpText?: string,
    group_question_id?: string,
    multiple?: boolean
  ): IAnswer {
    const queId = crypto.randomUUID();
    const ansId = crypto.randomUUID();
    return {
      active: true,
      application_form_id: formid,
      id: ansId,
      is_completed: false,
      question: {
        code: code,
        error_text: errorText,
        help_text: helpText,
        field_type: fieldType,
        id: queId,
        question_group_id: group_question_id,
        question_set_id: queSetId,
        required: required,
        text: queText,
        autocomplete: true,
        multiple: multiple,
        reference_type: referenceType,
        pattern: pattern,
        placeholder: placeholder,
        min_length: minlength,
        max_length: maxlength,
        min_value: min,
        max_value: max,
        hide_label: hide_label,
        choices: choices
      },
      required: required,
      value: null,
      choice_id: null,
      choice_ids: [null]
    };
  }
  private getStates(quesId: string): IChoice[] {
    const states: IChoice[] = [];
    states.push(this.createChoice(quesId, 'Alaska', 'AK'));
    states.push(this.createChoice(quesId, 'Alabama', 'AL'));
    states.push(this.createChoice(quesId, 'Arkansas', 'AR'));
    states.push(this.createChoice(quesId, 'Arizona', 'AZ'));
    states.push(this.createChoice(quesId, 'California', 'CA'));
    states.push(this.createChoice(quesId, 'Colorado', 'CO'));
    states.push(this.createChoice(quesId, 'Connecticut', 'CT'));
    states.push(this.createChoice(quesId, 'District of Columbia', 'DC'));
    states.push(this.createChoice(quesId, 'Delaware', 'DE'));
    states.push(this.createChoice(quesId, 'Florida', 'FL'));
    states.push(this.createChoice(quesId, 'Georgia', 'GA'));
    states.push(this.createChoice(quesId, 'Hawaii', 'HI'));
    states.push(this.createChoice(quesId, 'Iowa', 'IA'));
    states.push(this.createChoice(quesId, 'Idaho', 'ID'));
    states.push(this.createChoice(quesId, 'Illinois', 'IL'));
    states.push(this.createChoice(quesId, 'Indiana', 'IN'));
    states.push(this.createChoice(quesId, 'Kansas', 'KS'));
    states.push(this.createChoice(quesId, 'Kentucky', 'KY'));
    states.push(this.createChoice(quesId, 'Louisiana', 'LA'));
    states.push(this.createChoice(quesId, 'Massachusetts', 'MA'));
    states.push(this.createChoice(quesId, 'Maryland', 'MD'));
    states.push(this.createChoice(quesId, 'Maine', 'ME'));
    states.push(this.createChoice(quesId, 'Michigan', 'MI'));
    states.push(this.createChoice(quesId, 'Minnesota', 'MN'));
    states.push(this.createChoice(quesId, 'Missouri', 'MO'));
    states.push(this.createChoice(quesId, 'Mississippi', 'MS'));
    states.push(this.createChoice(quesId, 'Montana', 'MT'));
    states.push(this.createChoice(quesId, 'North Carolina', 'NC'));
    states.push(this.createChoice(quesId, 'North Dakota', 'ND'));
    states.push(this.createChoice(quesId, 'Nebraska', 'NE'));
    states.push(this.createChoice(quesId, 'New Hampshire', 'NH'));
    states.push(this.createChoice(quesId, 'New Jersey', 'NJ'));
    states.push(this.createChoice(quesId, 'New Mexico', 'NM'));
    states.push(this.createChoice(quesId, 'Nevada', 'NV'));
    states.push(this.createChoice(quesId, 'New York', 'NY'));
    states.push(this.createChoice(quesId, 'Ohio', 'OH'));
    states.push(this.createChoice(quesId, 'Oklahoma', 'OK'));
    states.push(this.createChoice(quesId, 'Oregon', 'OR'));
    states.push(this.createChoice(quesId, 'Pennsylvania', 'PA'));
    states.push(this.createChoice(quesId, 'Rhode Island', 'RI'));
    states.push(this.createChoice(quesId, 'South Carolina', 'SC'));
    states.push(this.createChoice(quesId, 'South Dakota', 'SD'));
    states.push(this.createChoice(quesId, 'Tennessee', 'TN'));
    states.push(this.createChoice(quesId, 'Texas', 'TX'));
    states.push(this.createChoice(quesId, 'Utah', 'UT'));
    states.push(this.createChoice(quesId, 'Virginia', 'VA'));
    states.push(this.createChoice(quesId, 'Vermont', 'VT'));
    states.push(this.createChoice(quesId, 'Washington', 'WA'));
    states.push(this.createChoice(quesId, 'Wisconsin', 'WI'));
    states.push(this.createChoice(quesId, 'West Virginia', 'WV'));
    states.push(this.createChoice(quesId, 'Wyoming', 'WY'));
    return states;
  }
  private createChoice(quesId: string, val: string, alias?: string): IChoice {
    const choice: IChoice = {
      id: crypto.randomUUID(),
      question_id: quesId,
      value: val,
      alias: alias
    };
    return choice;
  }
  private getProducts(quesId: string): IChoice[] {
    const states: IChoice[] = [];
    states.push(this.createChoice(quesId, 'General Liability', 'GL'));
    states.push(this.createChoice(quesId, 'Professional Liability', 'PL'));
    states.push(this.createChoice(quesId, 'Workers Compensation', 'WC'));
    states.push(this.createChoice(quesId, 'Business Owners Policy', 'BO')); //Changed the mapping from 'BOP' to 'BO'
    return states;
  }
}
